module.exports = __webpack_public_path__ + "static/img/Andrew-Davey.637b707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew-Davey.jpg
// module id = 1LUO
// module chunks = 0